module.exports = __webpack_public_path__ + "img/cell_size_4.62364b0c.svg";